import { useAuthStore } from '@src/stores/auth';
import { useInternalChatStore } from '@src/stores/internalChat';
import InternalMessage from '@src/types/InternalMessage';
import '@src/services/echo';
import NotificationsService from '@src/services/notifications';
import useStore from '@src/stores/store';
import InternalChatService from '@src/services/internalChat';

type NewInternalMessagePayload = { message: InternalMessage };
type InternalMessagesReadPayload = { conversation_id: number; read_at: string };

export function InternalChatListeners(): void {
    const auth = useAuthStore();
    const internalChatStore = useInternalChatStore();
    const appStore = useStore();

    const userId = auth.user?.id;
    if (!userId) return;

    // @ts-ignore
    const channel = window.websockets.private(`user.${userId}`);

    channel.listen('.NewInternalMessage', (event: NewInternalMessagePayload) => {
        try {
            if (!event?.message?.id) return;
            internalChatStore.receiveMessage(event.message);

            const isViewingThisConversation =
                appStore.activeSidebarComponent === 'internal-chat' &&
                internalChatStore.selectedUserId === event.message.sender_id;

            if (isViewingThisConversation) {
                InternalChatService.markRead(event.message.sender_id).catch(() => {});
            } else {
                const sender = internalChatStore.users.find(u => u.id === event.message.sender_id);
                NotificationsService.notify(`${sender?.name ?? 'Alguém'}: nova mensagem interna.`);
            }
        } catch (e) {
            console.error('❌ erro no listener NewInternalMessage', e);
        }
    });

    channel.listen('.InternalMessagesRead', (event: InternalMessagesReadPayload) => {
        try {
            if (!event?.conversation_id || !event?.read_at) return;
            internalChatStore.markMessagesAsRead(event.conversation_id, event.read_at);
        } catch (e) {
            console.error('❌ erro no listener InternalMessagesRead', e);
        }
    });
}
